module.exports = __webpack_public_path__ + "img/sidebar.22bb5dd0.gif";